export default {
	validate: {},
	locales: {
		en: 'English',
		ru: 'Russian',
		uk: 'Ukrainian'
	},
	cities: {
		kyv: 'Kyiv',
		umn: 'Uman',
		vin: 'Vinnytsia'
	},
	menu: {
		Login: 'Login',
		Register: 'Register',
		Dashboard: 'Dashboard'
	},
	buttons: {
		confirm: 'Confirm',
		cancel: 'Cancel',
		repeat: 'Repeat',
		ok: 'OK'
	},
	pages: {
		Login: {
			title: 'Login in system',
			submit: 'Login',
			confirm: 'Confirm Login',
			withoutSMS: 'No sms or change number?',
			problemWithCode: 'Have trouble getting a verification code?',
			changePhone: 'Change phone number',
			dontGetSms: 'Not received SMS',
			form: {
				phoneNumber: {
					countrySelectorLabel: 'Country code',
					countrySelectorError: 'Choose a country',
					phoneNumberLabel: 'Phone number',
					example: 'Example: '
				}
			}
		},
		Dashboard: {
			streets: {
				noResults: 'No results matching',
				0: 'Where from - Start input for search ...',
				1: 'Where - Start input for search ...'
			},
			house: 'House',
			statuses: {
				searching: 'Searching',
				'driver-assigned': 'Driver assigned',
				arrived: 'Driver arrived',
				cancelled: 'Cancelled'
			},
			reverseSearch: 'Select a point on the map',
			outCity: 'Out city',
			continueSearch: 'Keep searching ...',
			rate: 'Rate',
			options: 'Options',
			driver: 'Driver',
			others: 'others',
			yourOrder: 'Your order',
			orderTaxi: 'Order taxi',
			createAnotherOrder: 'Create another order',
			canCancelOrder: 'Want to cancel this order?',
			cancelDescription: 'Through frequent cancellations of orders already accepted by drivers, the ability to create new orders may be blocked for some time.',
			noItems: 'No items found',
			comment: 'Comment'
		},
		404: {
			title: 'Oops!',
			text: 'Looks like you\'re in uncharted territory. We don\'t know about this page yet. Luckily, we know the way back.',
			return: 'Back'
		}
	},
	messages: {
		info: {
			pushLoginCode: 'An SMS with a verification code has been sent to your phone'
		},
		success: {
			login: 'Welcome to us!'
		},
		error: {
			incorrectConfirmCode: 'Invalid verification code entered',
			unknown: 'Unknown error',
			incorrectEnterNumber: 'Enter a number'
		}
	},
	noDataText: 'not items'
}
